import React from 'react'
import { Solicitudes } from '../components/SolicitudPDFs/Solicitudes'
import '../css/evidencias.css';
export const SolicitudesPage = () => {
  return (
    <Solicitudes/>
  )
}
